import { MetaDataDescriptions } from '../meta-data/meta-data-descriptions';
import { Expose, Type } from '@nts/std/serialization';
import { CustomFieldMetaData } from './custom-field-meta-data';
import { ExternalLayoutMetaData } from './external-layout-meta-data';
import { GridMetaData } from './grid-meta-data';
import { SimpleFieldMetaData } from './simple-field-meta-data';
import { SpacerMetaData } from './spacer-meta-data';
import { FieldTypes, PanelState } from '@nts/std/types';
import type { CustomFieldMetaDataInterface, ExternalLayoutMetaDataInterface, FieldMetaDataInterface, GridMetaDataInterface, MetaDataDescriptionsInterface, SimpleFieldMetaDataInterface, SpacerMetaDataInterface } from '@nts/std/interfaces';
import type { PanelMetaDataInterface } from '@nts/std/interfaces';

export class PanelMetaData implements PanelMetaDataInterface {

  constructor() {
    this.descriptions = new MetaDataDescriptions();

    this.simpleFields = [];
    this.spacers = [];
    this.grids = [];
    this.externals = [];
    this.customFields = [];
    this.promotedFields = [];
    this.fieldType = FieldTypes.Panel;
  }

  @Expose()
  panelState: PanelState;

  @Expose()
  fieldType: FieldTypes;

  @Expose()
  isVisible: boolean;

  @Expose()
  @Type(() => MetaDataDescriptions)
  descriptions: MetaDataDescriptionsInterface;

  @Expose()
  @Type(() => SimpleFieldMetaData)
  simpleFields: SimpleFieldMetaDataInterface[];

  @Expose()
  @Type(() => SpacerMetaData)
  spacers: SpacerMetaDataInterface[];

  @Expose()
  @Type(() => GridMetaData)
  grids: GridMetaDataInterface[];

  @Expose()
  @Type(() => ExternalLayoutMetaData)
  externals: ExternalLayoutMetaDataInterface[];

  @Expose()
  @Type(() => CustomFieldMetaData)
  customFields: CustomFieldMetaDataInterface[];

  @Expose()
  promotedFields: string[];

  @Expose()
  position: number;

  @Expose()
  panelId: string;

  @Expose()
  get additionalFields(): string[] {
    return [...this.simpleFields, ...this.grids, ...this.externals]
      .filter((field) => field?.isAdditionalField == true)
      .map((field) => field?.path?.length > 0 ? field.path + '.' + field.name : field.name);
  }

  @Expose()
  get sortedFields(): FieldMetaDataInterface[] {
    return [...this.spacers, ...this.simpleFields, ...this.grids, ...this.externals, ...this.customFields].sort((a, b) => a.position - b.position);
  }

  @Expose()
  disableToggle: boolean = false;

  @Expose()
  showHeader: boolean = true;

}
